/**
 * Universal pluralization function for Slavic languages.
 * @param {number} count - The number to pluralize.
 * @param {string[]} forms - Array of [singular, few, many] forms.
 * Example: plural(3, ['гість', 'гостя', 'гостей'])
 * @returns {string}
 */
export function plural(count, forms) {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return `${count} ${forms[0]}`;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20))
    return `${count} ${forms[1]}`;
  return `${count} ${forms[2]}`;
}
